import React from 'react';

export const CustomInput = React.forwardRef<HTMLInputElement>((props, ref) => {
  return <input type="text" ref={ref} {...props} />;
});

CustomInput.displayName = 'CustomInput';
